import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { getControlpanel } from '@plone/volto/actions';
import { Controlpanel, Toast } from '@plone/volto/components';
import { Button, Container, Segment } from 'semantic-ui-react';
import { getBaseUrl } from '@plone/volto/helpers';
import { toast } from 'react-toastify';

const PalafollsControlPanel = (props) => {
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const controlPanelId = 'palafolls-controlpanel';

    const controlpanelProps = {
        ...props,
        match: {
        ...props.match,
        params: {
            ...props.match?.params,
            id: controlPanelId,
        },
        },
    };

    const handleImportTramits = async () => {
        setLoading(true);
        const baseUrl = getBaseUrl(props.location.pathname);
        
        try {
        const response = await fetch(`${baseUrl}/@@import_tramits`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        });
        
        if (response.ok) {
            toast.success(
                <Toast
                    success
                    title="Importació completa"
                    content="Els tràmits s'han importat correctament."
                />
            );
            dispatch(getControlpanel(controlPanelId));
        } else {
            toast.error(
            <Toast
                error
                title="Error d'importació"
                content={`El servidor ha retornat un error: ${response.status}`}
            />
            );
        }
        } catch (error) {
            toast.error(
                <Toast
                error
                title="Error de xarxa"
                content="No s'ha pogut connectar amb el servidor."
                />
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container className="palafolls-controlpanel">

            <h1>Configuració Aj. Palafolls</h1>

            <Segment clearing padded vertical>
                <h2>Accions</h2>
                <Button 
                    primary 
                    loading={loading}
                    disabled={loading}
                    onClick={handleImportTramits}
                    >
                    Importar Tràmits
                </Button>
            </Segment>

            <h2>Configuracions</h2>
            <Controlpanel {...controlpanelProps} />
        </Container>
    );
};

export default PalafollsControlPanel